module.exports = __webpack_public_path__ + "static/img/history1.695fc800.png";